import React from 'react'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'

export default withTranslation()(function Pagination({ t, tKey, total, page, pageSize, onPageChange, onPageSizeChange, selectedCount = 0 }) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize))

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 px-4 py-3 border-t border-border-lines">
      <span className="text-sm text-secondary">
        {t(`${tKey}.selected`, { count: selectedCount, total })}
      </span>

      <div className="flex items-center gap-4">
        <select
          value={pageSize}
          onChange={(event) => onPageSizeChange(Number(event.target.value))}
          className="border border-border-lines rounded-lg px-2 py-1 text-sm text-dark-blue"
        >
          {[10, 20, 50].map((size) => <option key={size} value={size}>{size}</option>)}
        </select>

        <span className="text-sm text-secondary whitespace-nowrap">
          {t(`${tKey}.page_of`, { page: page + 1, total: totalPages })}
        </span>

        <div className="flex items-center gap-1">
          <button type="button" onClick={() => onPageChange(0)} disabled={page === 0} className="p-1 rounded disabled:opacity-30">
            <UIcons.UilAngleDoubleLeft size={16} className="text-secondary" />
          </button>
          <button type="button" onClick={() => onPageChange(page - 1)} disabled={page === 0} className="p-1 rounded disabled:opacity-30">
            <UIcons.UilAngleLeft size={16} className="text-secondary" />
          </button>
          <button type="button" onClick={() => onPageChange(page + 1)} disabled={page + 1 >= totalPages} className="p-1 rounded disabled:opacity-30">
            <UIcons.UilAngleRight size={16} className="text-secondary" />
          </button>
          <button type="button" onClick={() => onPageChange(totalPages - 1)} disabled={page + 1 >= totalPages} className="p-1 rounded disabled:opacity-30">
            <UIcons.UilAngleDoubleRight size={16} className="text-secondary" />
          </button>
        </div>
      </div>
    </div>
  )
})
